import { HEALTH_METRICS, healthDay, healthMetricValue, moveHealthDay } from "./healthStatistics"
import { hubDay, hubPeriod, hubStatistics } from "./customerHubActivityData"

const ORDER = ["sleepSeconds", "steps", "heartRate", "totalEnergyKilocalories", "activeEnergyKilocalories", "distanceMeters", "weightKilograms"]
const usable = value => typeof value === "number" && Number.isFinite(value) && value >= 0

// Presentation only. Never retain health values or copy them into route queries.
export function overviewHealthMetrics(state, owner, today = healthDay()) {
  if (!owner || state.ownerId !== owner || !state.android || !state.supported || !state.enabled) return []
  const snapshot = state.snapshot?.day === today ? state.snapshot.daily || {} : {}
  const record = state.history?.days?.find(day => day.day === today && day.readable && !day.future)
  return ORDER.map(key => {
    const metric = HEALTH_METRICS.find(item => item.key === key)
    const granted = state.grantedCategories.includes(metric.category)
    const fromSnapshot = granted && usable(snapshot[key])
    const raw = granted ? fromSnapshot ? snapshot[key] : record?.values?.[key] : null
    const value = usable(raw) ? raw : null
    const measuredAt = fromSnapshot && ["heartRate", "weightKilograms"].includes(key)
      ? snapshot[key === "heartRate" ? "heartRateMeasuredAt" : "weightMeasuredAt"] : null
    const bars = []
    if (granted && ["steps", "sleepSeconds"].includes(key)) {
      for (let i = -6; i <= 0; i++) {
        const day = moveHealthDay(today, i), item = state.history?.days?.find(item => item.day === day && item.readable && !item.future)
        const sample = day === today && value !== null ? value : item?.values?.[key]
        bars.push({ day, value: usable(sample) ? sample : null })
      }
    }
    const max = Math.max(1, ...bars.map(bar => bar.value || 0))
    return { ...metric, label: key === "totalEnergyKilocalories" ? "Gesamtverbrauch" : metric.label, day: today, granted, value,
      display: value === null ? "–" : healthMetricValue(key, value), measuredAt: usable(measuredAt) && measuredAt > 0 ? measuredAt : null,
      kind: key === "heartRate" ? fromSnapshot ? "last" : "average" : "daily",
      bars: bars.map(bar => ({ ...bar, height: bar.value === null ? 2 : Math.max(2, bar.value / max * 32) })) }
  }).filter((metric, index) => index < 3 || metric.granted)
}

// Legacy preview is explicitly limited to loaded own Roody sessions. Pilot totals
// continue to use the existing multi-source service and its deduplication rules.
export function overviewTrainingWeek(sessions, owner, anchor = hubDay()) {
  const range = hubPeriod("week", anchor), seen = new Set(), activities = []
  for (const session of sessions) {
    const item = session?.execution, id = String(item?._id || "")
    if (!owner || !id || seen.has(id) || String(item.user_id?._id || item.user_id || "") !== owner) continue
    seen.add(id)
    const recordedAt = Number(item.ts) > 0 ? Number(item.ts) * 1000 : item.endedAt || item.createdAt
    if (!recordedAt) continue
    const date = hubDay(recordedAt)
    if (!date || date > anchor) continue
    const duration = Number(item.duration)
    activities.push({ id, date, status: "completed", source: "roody_v2", sourceName: "Roody", durationSourceName: "Roody",
      durationSeconds: item.duration !== null && item.duration !== "" && Number.isFinite(duration) && duration > 0 ? duration : null })
  }
  return hubStatistics(activities, [], range)
}
